import { Http } from '@diritto/common/utils/requester/http';
import { ProfileReplyCountResponseDto } from '@diritto/common/reply/dtos/reply.response.dto';

export class ProfileReplyApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getProfileReplyCount(profileId: number) {
    const res = await this.http.get<ProfileReplyCountResponseDto>(`${this.url}/profiles/${profileId}/replies/count`);
    return res.data;
  }
}
